/**
 * Professional Profile APIs (BC_PROF_BASE = /api/secure/bc/professional-profile)
 * Employee validation + nominated relatives.
 * See docs/portals/business/business-portal-updated-items.md
 */
import { getBPDataWithParams, getBPDataWithoutParams, postBPDataWithoutParams } from '../../index'

const PROF_BASE = '/api/secure/bc/professional-profile'

/** GET /api/secure/bc/professional-profile/me */
export function getProfessionalProfileMe() {
  return getBPDataWithoutParams(`${PROF_BASE}/me`)
}

/** GET .../validate/email?email=...&excludeEmployeeId=...&enforceCompanyDomain=true */
export function validateEmployeeEmail(params) {
  const { email, excludeEmployeeId, enforceCompanyDomain = true } = params
  const query = { email, enforceCompanyDomain }
  if (excludeEmployeeId) query.excludeEmployeeId = excludeEmployeeId
  return getBPDataWithParams(`${PROF_BASE}/validate/email`, query)
}

/** GET .../validate/mobile?mobile=...&excludeEmployeeId=... */
export function validateEmployeeMobile(params) {
  const { mobile, excludeEmployeeId } = params
  const query = { mobile }
  if (excludeEmployeeId) query.excludeEmployeeId = excludeEmployeeId
  return getBPDataWithParams(`${PROF_BASE}/validate/mobile`, query)
}

/** GET /api/secure/bc/professional-profile/relatives */
export function getRelatives() {
  return getBPDataWithoutParams(`${PROF_BASE}/relatives`)
}

/** POST /api/secure/bc/professional-profile/relatives/upsert */
export function upsertRelative(body) {
  return postBPDataWithoutParams(`${PROF_BASE}/relatives/upsert`, body)
}

/** POST /api/secure/bc/professional-profile/relatives/remove */
export function removeRelative(body) {
  return postBPDataWithoutParams(`${PROF_BASE}/relatives/remove`, body)
}
